"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React, { useContext, useRef, useState } from "react";
import {
  Form as ReactFinalFormComponent,
  Field,
  FormSpy as ReactFinalFormSpy
} from "react-final-form";
import { FORM_ERROR } from "final-form";
import setFieldData from "final-form-set-field-data";
import classNames from "classnames";
import { cloneDeep, identity, isEmpty } from "lodash";
import Button, { ButtonState } from "../Button/Button";
import {
  SegmentedControl,
  SegmentedControlOption
} from "../SegmentedControl/SegmentedControl";
import { Select } from "../Select";
import TextInput from "../TextInput/TextInput";
import { mapTextInputProps, mapSegmentedControlProps, mapSelectProps, mapCheckboxProps } from "./mapFormProps";
import {
  getTextInputSize,
  getSegmentedControlSize,
  getSelectSize,
  getButtonSize,
  getCheckboxSize
} from "./mapFormSizes";
import { Checkbox } from "../Checkbox/Checkbox";
export const FormContext = React.createContext(null);
export const ValidationSpy = ({ mutators, name }) => /* @__PURE__ */ React.createElement(
  ReactFinalFormSpy,
  {
    subscription: { active: true, modified: true, hasValidationErrors: true, errors: true },
    onChange: (data) => {
      var _a, _b;
      const isActiveField = data.active === name;
      if (!isActiveField && data.modified && data.modified[name] && ((_a = data.errors) == null ? void 0 : _a[name])) {
        mutators == null ? void 0 : mutators["setFieldData"](name, {
          showValidationErrors: true
        });
      }
      if (!((_b = data.errors) == null ? void 0 : _b[name])) {
        mutators == null ? void 0 : mutators["setFieldData"](name, {
          showValidationErrors: false
        });
      }
    }
  }
);
export const FormTextInput = (props) => {
  var _a;
  const context = useContext(FormContext);
  const size = getTextInputSize(context == null ? void 0 : context.fieldSize);
  const focus = (_a = context == null ? void 0 : context.form) == null ? void 0 : _a.focus;
  const { name, autoFocus } = props;
  React.useEffect(() => {
    if (autoFocus) {
      focus == null ? void 0 : focus(name);
    }
  }, [autoFocus, name, focus]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, __spreadValues({ className: "form-v2__field", initialValue: "", parse: identity }, props), mapTextInputProps((fieldProps) => /* @__PURE__ */ React.createElement(TextInput, __spreadValues({ size }, fieldProps)))), /* @__PURE__ */ React.createElement(ValidationSpy, { name: props.name, mutators: context == null ? void 0 : context.mutators }));
};
export const FormSegmentedControl = (_a) => {
  var _b = _a, {
    options
  } = _b, props = __objRest(_b, [
    "options"
  ]);
  const context = useContext(FormContext);
  const size = getSegmentedControlSize(context == null ? void 0 : context.fieldSize);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, __spreadValues({ parse: identity, className: "form-v2__field" }, props), mapSegmentedControlProps((fieldProps) => /* @__PURE__ */ React.createElement(SegmentedControl, __spreadProps(__spreadValues({}, fieldProps), { size }), options.map((option) => /* @__PURE__ */ React.createElement(SegmentedControlOption, __spreadValues({ key: option.value.toString() }, option)))))), /* @__PURE__ */ React.createElement(ValidationSpy, { name: props.name, mutators: context == null ? void 0 : context.mutators }));
};
export const FormCheckbox = ({ name, initialValue, validate, label, children, labelHidden }) => {
  const context = useContext(FormContext);
  const size = getCheckboxSize(context == null ? void 0 : context.fieldSize);
  const ariaLabelledBy = "checkbox-error";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Field,
    {
      name,
      type: "checkbox",
      parse: identity,
      initialValue: initialValue != null ? initialValue : false,
      validate
    },
    (fieldProps) => {
      const error = mapCheckboxProps(fieldProps);
      return /* @__PURE__ */ React.createElement("div", { className: "checkbox-container" }, /* @__PURE__ */ React.createElement(
        Checkbox,
        {
          checked: !!fieldProps.input.checked,
          id: name,
          label: children || label,
          labelHidden,
          size,
          error,
          onChange: () => {
            const next = fieldProps.input.checked !== void 0 ? !fieldProps.input.checked : true;
            fieldProps.input.onChange(next);
            fieldProps.input.onBlur();
          },
          onFocus: fieldProps.input.onFocus
        }
      ));
    }
  ), /* @__PURE__ */ React.createElement(ValidationSpy, { name, mutators: context == null ? void 0 : context.mutators }));
};
export const FormSelect = (props) => {
  const context = useContext(FormContext);
  const size = getSelectSize(context == null ? void 0 : context.fieldSize);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, __spreadValues({ parse: identity, className: "form-v2__field" }, props), mapSelectProps((fieldProps) => {
    return /* @__PURE__ */ React.createElement(Select, __spreadValues({ size }, fieldProps), props.children);
  })), /* @__PURE__ */ React.createElement(ValidationSpy, { name: props.name, mutators: context == null ? void 0 : context.mutators }));
};
export const FormSubmitButton = (_c) => {
  var _d = _c, { children, className } = _d, rest = __objRest(_d, ["children", "className"]);
  const context = useContext(FormContext);
  const size = getButtonSize(context == null ? void 0 : context.fieldSize);
  let buttonState;
  if (rest.buttonState) {
    buttonState = rest.buttonState;
  } else {
    buttonState = (context == null ? void 0 : context.submitting) ? ButtonState.Waiting : ButtonState.Idle;
  }
  return /* @__PURE__ */ React.createElement(Button, __spreadProps(__spreadValues({}, rest), { className: classNames("form-v2__submit-button", className), buttonState, size }), children);
};
export const FormComponent = React.forwardRef(
  (_e, ref) => {
    var _f = _e, { onSubmit, fieldSize, className, children, shakeOnError = true } = _f, customDataAttributes = __objRest(_f, ["onSubmit", "fieldSize", "className", "children", "shakeOnError"]);
    const [shaking, setShaking] = useState(false);
    const shake = () => {
      setShaking(false);
      window.requestAnimationFrame(() => {
        setShaking(true);
      });
    };
    const handleSubmit = (values) => __async(void 0, null, function* () {
      const submissionResult = yield onSubmit(values);
      if (submissionResult && shakeOnError) {
        shake();
      }
      return submissionResult;
    });
    return /* @__PURE__ */ React.createElement(ReactFinalFormComponent, { onSubmit: handleSubmit, mutators: { setFieldData }, destroyOnUnregister: true }, ({ handleSubmit: handleSubmit2, submitError, submitting, form, values, errors }) => {
      return /* @__PURE__ */ React.createElement(
        FormContext.Provider,
        {
          value: {
            submitError,
            submitting,
            fieldSize,
            mutators: form.mutators,
            values,
            form
          }
        },
        /* @__PURE__ */ React.createElement(
          "form",
          __spreadProps(__spreadValues({
            ref,
            onSubmit: (ev) => {
              for (const key in values) {
                form.mutators["setFieldData"](key, { showValidationErrors: true });
              }
              if (!isEmpty(errors) && shakeOnError) {
                shake();
              }
              handleSubmit2(ev);
            }
          }, customDataAttributes), {
            className: classNames("form-v2__form", { ["form-v2__form--has-error"]: shaking }, className)
          }),
          children
        )
      );
    });
  }
);
export const createFormSubmitErrorObject = (submitErrorMessage, fieldErrorMessages = {}) => {
  return __spreadValues({ [FORM_ERROR]: submitErrorMessage }, fieldErrorMessages);
};
export const OnFieldValueChangeSpy = (props) => {
  const activeField = useRef(null);
  const storedValues = useRef(null);
  return /* @__PURE__ */ React.createElement(
    ReactFinalFormSpy,
    {
      subscription: { active: true, errors: true, values: true },
      onChange: (form) => {
        var _a, _b, _c, _d, _e, _f;
        if (form.active && form.active === activeField.current) {
          return;
        }
        for (const [fieldName, fieldValue] of Object.entries(form.values)) {
          if (storedValues.current !== null && ((_a = storedValues.current) == null ? void 0 : _a[fieldName]) !== void 0 && ((_b = storedValues.current) == null ? void 0 : _b[fieldName]) !== fieldValue) {
            let errorMessage;
            if (((_c = form.errors) == null ? void 0 : _c[fieldName]) && ((_d = storedValues.current) == null ? void 0 : _d[fieldName])) {
              errorMessage = (_e = form.errors) == null ? void 0 : _e[fieldName];
            }
            props.onChange(fieldName, errorMessage);
          }
        }
        storedValues.current = form.values ? cloneDeep(form.values) : null;
        if (form.active !== activeField.current) {
          activeField.current = (_f = form.active) != null ? _f : null;
        }
      }
    }
  );
};
export const OnSubmitFailedSpy = (props) => {
  return /* @__PURE__ */ React.createElement(
    ReactFinalFormSpy,
    {
      subscription: { errors: true, submitFailed: true, modifiedSinceLastSubmit: true },
      onChange: ({ errors, submitFailed, modifiedSinceLastSubmit }) => {
        if (!modifiedSinceLastSubmit && submitFailed) {
          props.onSubmitFailed(errors != null ? errors : void 0);
        }
      }
    }
  );
};
